module.exports = __webpack_public_path__ + "img/logo256x256.e1b9ff8c.png";